export const METADATA = 'METADATA';


// WEBPACK FOOTER //
// ./src/actions/metadata/types.js